<template>
  <div class="main-wrapper" v-if="items">
    <el-tabs v-model="status" @tab-click="btnNavClick">
      <el-tab-pane :label="'全部订单(' + allCount + ')'" name=""></el-tab-pane>
      <el-tab-pane :label="'未开发票订单(' + defaultCount + ')'" name="Default"></el-tab-pane>
      <el-tab-pane :label="'已开发票订单(' + invoicedCount + ')'" name="Invoiced"></el-tab-pane>
      <el-tab-pane :label="'退款订单(' + refundedCount + ')'" name="Refunded"></el-tab-pane>
    </el-tabs>

    <el-table :data="items" style="width: 100%">
      <el-table-column width="160" label="订单号">
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            @click.prevent.prevent="btnOrderClick(scope.row)"
          >
            {{ scope.row.orderNo }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="用户">
        <template #default="scope">
          {{ scope.row.userName }}
        </template>
      </el-table-column>
      <el-table-column label="订单类型">
        <template #default="scope">
          {{ getResourceType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template #default="scope">
          <el-link :href="getUrl(scope.row)" :underline="false" target="_blank" type="primary">
            {{ scope.row.resourceTitle }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center">
        <template #default="scope">￥{{ scope.row.amount.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="支付方式" align="center">
        <template #default="scope">
          {{ getChannel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="支付时间" width="140" align="center">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template #default="scope">
          {{ getOrderStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            v-if="scope.row.status === statusOrderDefault"
            @click.prevent="btnRefundClick(scope.row)"
          >
            退 款
          </el-link>
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            v-if="scope.row.status === statusOrderInvoiced"
            @click.prevent="apiGetInvoice(scope.row)"
          >
            发票信息
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer title="订单信息" direction="rtl" size="60%" v-if="order" v-model="isTableOrder">
      <table-order :order="order"></table-order>
    </el-drawer>

    <el-drawer title="发票信息" direction="rtl" size="60%" v-if="invoice" v-model="isTableInvoice">
      <table-invoice :invoice="invoice"></table-invoice>
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IInvoice, IOrder } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/orders';
import TableOrder from './components/orders/TableOrder.vue';
import TableInvoice from './components/orders/TableInvoice.vue';

interface IState {
  statusOrderDefault: string;
  statusOrderInvoiced: string;
  statusOrderRefunded: string;
  status: string;
  items: IOrder[];
  allCount: number;
  defaultCount: number;
  invoicedCount: number;
  refundedCount: number;
  order: IOrder;
  isTableOrder: boolean;
  invoice: IInvoice;
  isTableInvoice: boolean;
}

export default defineComponent({
  components: { TableOrder, TableInvoice },
  data() {
    return {
      statusOrderDefault: 'Default',
      statusOrderInvoiced: 'Invoiced',
      statusOrderRefunded: 'Refunded',
      status: this.$route.query.status || '',
      items: [],
      allCount: 0,
      defaultCount: 0,
      invoicedCount: 0,
      refundedCount: 0,
      order: {} as IOrder,
      isTableOrder: false,
      invoice: {} as IInvoice,
      isTableInvoice: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          status: this.status,
        },
        (res) => {
          this.items = res.items;
          this.allCount = res.allCount;
          this.defaultCount = res.defaultCount;
          this.invoicedCount = res.invoicedCount;
          this.refundedCount = res.refundedCount;
        },
      );
    },

    apiRefund(order: IOrder) {
      api.refund(
        {
          orderId: order.guid,
        },
        (res) => {
          if (!res) return;
          utils.success('订单退款成功！');
          this.apiGet();
        },
      );
    },

    apiGetInvoice(order: IOrder) {
      api.getInvoice(
        {
          invoiceId: order.invoiceId,
        },
        (res) => {
          if (!res) return;
          this.invoice = res.invoice;
          this.isTableInvoice = true;
        },
      );
    },

    getOrderStatus(status: string) {
      if (status === this.statusOrderDefault) {
        return '待开发票';
      }
      if (status === this.statusOrderInvoiced) {
        return '已开发票';
      }
      if (status === this.statusOrderRefunded) {
        return '已退款';
      }
      return '待开发票';
    },

    getResourceType(item: IOrder) {
      return utils.getResourceType(item.resourceType);
    },

    getChannel(item: IOrder) {
      return utils.getPayChannel(item.channel);
    },

    getUrl(item: IOrder) {
      return utils.getResourceUrl(item.resourceType, item.resourceId);
    },

    btnNavClick() {
      this.apiGet();
    },

    btnOrderClick(order: IOrder) {
      this.order = order;
      this.isTableOrder = true;
    },

    btnRefundClick(order: IOrder) {
      utils.alertDelete(
        {
          title: '订单退款',
          text: `此操作将把订单${order.orderNo}全款退回并设置订单为已退款，确定吗？`,
          button: '确认退款',
        },
        () => {
          this.apiRefund(order);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
